import { DocumentNode, gql } from '@apollo/client'

export const UPDATE_DAYCARE_ACCESSIBILITY: DocumentNode = gql`
    mutation updateDaycareAccessibility($accessibility: AccessibilityInput!) {
        updateDaycareAccessibility(accessibility: $accessibility)
    }
`

export const DELETE_DAYCARE_ACCESSIBILITY: DocumentNode = gql`
    mutation deleteDaycareAccessibility($accessibility_id: Int!) {
        deleteDaycareAccessibility(accessibility_id: $accessibility_id)
    }
`

export const CREATE_DAYCARE_ACCESSIBILITY: DocumentNode = gql`
    mutation createDaycareAccessibility($daycare_id: Int!, $type: AccessibilityType!, $start: Time!, $end: Time!) {
        createDaycareAccessibility(daycare_id: $daycare_id, type: $type, start: $start, end: $end)
    }
`
